import React from "react"
import type { Locale } from "popopo-msg/routes"
import { SimplePage, PopopoLogoSlant, ActionButton } from "../components"
import { getMessages } from "../messages"

interface NotFoundPageProps {
  locale: Locale
  homeUrl?: string
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({
  locale,
  homeUrl = "/",
}) => {
  const msg = getMessages(locale)

  return (
    <SimplePage locale={locale}>
      <PopopoLogoSlant color="#E0E0E0" height={80} className="simple-page__logo" />
      <h1 className="simple-page__title">{msg.notFound.title}</h1>
      <p className="simple-page__description">{msg.notFound.description}</p>
      <ActionButton href={homeUrl} variant="outlined">
        {msg.notFound.backButton}
      </ActionButton>
    </SimplePage>
  )
}
